/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import { useMemo } from "react";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import EventDropzone from "../EventDropzone";
import EventImage from "../EventImage";
import MDEditorField from "../MDEditorField";
import ImageField from "../ImageField";

function Media({formData}) {
  const { formField, values, errors, touched, setFieldValue } = formData;
  const { cover } = formField;
  const { cover: coverV } = values;

  return (
    <MDBox>
      <MDTypography variant="h5">Media</MDTypography>
      <MDBox mt={3}>
        <ImageField label={cover.label}
                    name={cover.name}
                    value={coverV}
                    setFieldValue={setFieldValue}/>
      </MDBox>
    </MDBox>
  );
}

export default Media;
